
    document.querySelectorAll('.hnl-pdp[data-hnl-init]').forEach(function (root) {

      var hnlIsEn = (root.dataset.hnlLocale || 'fr').toLowerCase().indexOf('en') === 0;

      var mainImage = root.querySelector('[data-hnl-main-image]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hnl-thumb]'));
      var variantInputs = Array.prototype.slice.call(root.querySelectorAll('[data-hnl-variant-input]'));
      var variantRows = Array.prototype.slice.call(root.querySelectorAll('[data-hnl-variant-row]'));
      var toggleBtns = Array.prototype.slice.call(root.querySelectorAll('[data-hnl-toggle]'));
      var addToCartBtn = root.querySelector('[data-hnl-add-to-cart]');
      var currentPriceEl = root.querySelector('[data-hnl-current-price]');
      var currentCompareEl = root.querySelector('[data-hnl-current-compare]');
      var atcStatus = root.querySelector('[data-hnl-atc-status]');
      var deliveryDateEl = root.querySelector('[data-hnl-delivery-date]');
      var qtyInput = root.querySelector('[data-hnl-qty-input]');
      var qtyDecreaseBtn = root.querySelector('[data-hnl-qty-decrease]');
      var qtyIncreaseBtn = root.querySelector('[data-hnl-qty-increase]');
      var maxQuantity = qtyInput ? (parseInt(qtyInput.getAttribute('max'), 10) || 10) : 10;
      var stockBadge = root.querySelector('[data-hnl-stock-badge]');
      var stockDot = root.querySelector('[data-hnl-stock-dot]');
      var stockLabel = root.querySelector('[data-hnl-stock-label]');
      var stockCount = root.querySelector('[data-hnl-stock-count]');
      var atcLabel = root.querySelector('[data-hnl-atc-label]');
      var atcUnavailable = root.querySelector('[data-hnl-atc-unavailable]');
      var lowStockThreshold = stockBadge ? (parseInt(stockBadge.getAttribute('data-threshold'), 10) || 16) : 16;

      var drawerOverlay = root.querySelector('[data-hnl-drawer-overlay]');
      var drawer = root.querySelector('[data-hnl-drawer]');
      var drawerCloseEls = Array.prototype.slice.call(root.querySelectorAll('[data-hnl-drawer-close]'));
      var drawerItemImage = root.querySelector('[data-hnl-drawer-item-image]');
      var drawerItemTitle = root.querySelector('[data-hnl-drawer-item-title]');
      var drawerItemVariant = root.querySelector('[data-hnl-drawer-item-variant]');
      var drawerItemMeta = root.querySelector('[data-hnl-drawer-item-meta]');
      var drawerSummary = root.querySelector('[data-hnl-drawer-summary]');

      var isSubscribeActive = false;

      // Galerie : clic sur une miniature
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImage) {
            mainImage.src = thumb.getAttribute('data-full');
            var thumbImage = thumb.querySelector('img');
            mainImage.alt = thumbImage ? thumbImage.alt : '';
          }
        });
      });

      function formatMoney(cents) {
        return new Intl.NumberFormat(root.dataset.hnlLocale || 'fr', {
          style: 'currency',
          currency: root.dataset.hnlCurrency || 'EUR'
        }).format(cents / 100);
      }

      // Quantité : lecture/écriture toujours bornées entre 1 et le maximum autorisé
      function getQuantity() {
        if (!qtyInput) return 1;
        var val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        if (val > maxQuantity) val = maxQuantity;
        return val;
      }

      function setQuantity(val) {
        if (!qtyInput) return;
        val = Math.max(1, Math.min(maxQuantity, val));
        qtyInput.value = val;
        if (qtyDecreaseBtn) qtyDecreaseBtn.disabled = val <= 1;
        if (qtyIncreaseBtn) qtyIncreaseBtn.disabled = val >= maxQuantity;
        var checkedInput = root.querySelector('[data-hnl-variant-input]:checked');
        if (checkedInput) updatePriceDisplay(checkedInput);
      }

      function updatePriceDisplay(input) {
        var isSubscribe = isSubscribeActive && input.getAttribute('data-plan-id');
        var priceCents = isSubscribe ? input.getAttribute('data-plan-price') : input.getAttribute('data-price');
        var compareCents = input.getAttribute('data-compare');
        var qty = getQuantity();
        if (currentPriceEl && priceCents) currentPriceEl.textContent = formatMoney(parseInt(priceCents, 10) * qty);
        if (currentCompareEl) {
          if (!isSubscribe && compareCents && parseInt(compareCents, 10) > parseInt(input.getAttribute('data-price'), 10)) {
            currentCompareEl.textContent = formatMoney(parseInt(compareCents, 10) * qty);
            currentCompareEl.style.display = '';
          } else {
            currentCompareEl.style.display = 'none';
          }
        }
        if (addToCartBtn) addToCartBtn.setAttribute('data-variant-id', input.value);
      }

      // Indicateur de stock : vert si disponible en quantité suffisante, rouge si stock faible ou épuisé
      function updateStockDisplay(input) {
        if (!stockBadge || !input) return;
        var tracked = input.getAttribute('data-inventory-tracked') === 'true';
        var qtyRaw = parseInt(input.getAttribute('data-inventory'), 10);
        var qty = isNaN(qtyRaw) ? 0 : Math.max(qtyRaw, 0);
        var available = input.getAttribute('data-available') === 'true';
        var inLabel = stockBadge.getAttribute('data-in-label') || (hnlIsEn ? 'In stock' : 'En stock');
        var outLabel = stockBadge.getAttribute('data-out-label') || (hnlIsEn ? 'Out of stock' : 'Rupture de stock');

        stockBadge.classList.remove('is-in-stock', 'is-low-stock', 'is-out-of-stock');

        if (!available) {
          stockBadge.classList.add('is-out-of-stock');
          if (stockLabel) stockLabel.textContent = outLabel;
          if (stockCount) { stockCount.textContent = ''; stockCount.style.display = 'none'; }
          if (addToCartBtn) addToCartBtn.disabled = true;
          if (atcLabel) atcLabel.style.display = 'none';
          if (atcUnavailable) { atcUnavailable.textContent = outLabel; atcUnavailable.style.display = 'inline'; }
        } else {
          var isLow = tracked && qty < lowStockThreshold;
          stockBadge.classList.add(isLow ? 'is-low-stock' : 'is-in-stock');
          if (stockLabel) stockLabel.textContent = inLabel;
          if (stockCount) {
            if (tracked) {
              var suffix = hnlIsEn ? (isLow ? 'left' : 'available') : (isLow ? (qty > 1 ? 'restants' : 'restant') : (qty !== 1 ? 'disponibles' : 'disponible'));
              stockCount.textContent = '(' + qty + ' ' + suffix + ')';
              stockCount.style.display = '';
            } else {
              stockCount.textContent = '';
              stockCount.style.display = 'none';
            }
          }
          if (addToCartBtn) addToCartBtn.disabled = false;
          if (atcLabel) atcLabel.style.display = '';
          if (atcUnavailable) atcUnavailable.style.display = 'none';
        }
      }

      // Sélection d'une variante (sachet)
      variantInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          variantRows.forEach(function (row) { row.classList.remove('is-active'); });
          input.closest('[data-hnl-variant-row]').classList.add('is-active');
          var img = input.getAttribute('data-image');
          if (img && mainImage) {
            mainImage.src = img;
            var variantImage = input.closest('[data-hnl-variant-row]').querySelector('img');
            mainImage.alt = variantImage ? variantImage.alt : '';
          }
          updatePriceDisplay(input);
          updateStockDisplay(input);
        });
      });

      // Stepper de quantité
      if (qtyDecreaseBtn) {
        qtyDecreaseBtn.addEventListener('click', function () { setQuantity(getQuantity() - 1); });
      }
      if (qtyIncreaseBtn) {
        qtyIncreaseBtn.addEventListener('click', function () { setQuantity(getQuantity() + 1); });
      }
      if (qtyInput) {
        qtyInput.addEventListener('input', function () { setQuantity(getQuantity()); });
        qtyInput.addEventListener('blur', function () { setQuantity(getQuantity()); });
      }
      setQuantity(getQuantity());

      // Synchronise l'indicateur de stock avec la variante sélectionnée au chargement
      var initialCheckedInput = root.querySelector('[data-hnl-variant-input]:checked');
      if (initialCheckedInput) updateStockDisplay(initialCheckedInput);

      // Toggle achat unique / abonnement
      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          toggleBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          isSubscribeActive = btn.getAttribute('data-hnl-toggle') === 'subscribe';
          var checkedInput = root.querySelector('[data-hnl-variant-input]:checked');
          if (checkedInput) updatePriceDisplay(checkedInput);
        });
      });

      // Estimation de livraison
      if (deliveryDateEl) {
        var days = parseInt(deliveryDateEl.getAttribute('data-days'), 10) || 5;
        var target = new Date();
        target.setDate(target.getDate() + days);
        deliveryDateEl.textContent = target.toLocaleDateString(root.dataset.hnlLocale || 'fr-FR', { month: 'long', day: 'numeric' });
      }

      // Accordéons (indépendants, plusieurs ouverts possible)
      var accItems = Array.prototype.slice.call(root.querySelectorAll('[data-hnl-acc-item]'));
      accItems.forEach(function (item) {
        var trigger = item.querySelector('[data-hnl-acc-trigger]');
        var panel = item.querySelector('[data-hnl-acc-panel]');
        trigger.addEventListener('click', function () {
          var isOpen = item.classList.toggle('is-open');
          panel.classList.toggle('is-open', isOpen);
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });

      // Panier coulissant : ouverture / fermeture
      function openCartDrawer(item, cart) {
        if (!drawer) return;
        if (item) {
          if (drawerItemImage) {
            if (item.image) {
              drawerItemImage.src = item.image;
              drawerItemImage.alt = item.product_title || '';
              drawerItemImage.style.display = '';
            } else {
              drawerItemImage.style.display = 'none';
            }
          }
          if (drawerItemTitle) drawerItemTitle.textContent = item.product_title || '';
          if (drawerItemVariant) {
            var hasVariant = item.variant_title && item.variant_title !== 'Default Title';
            drawerItemVariant.textContent = hasVariant ? item.variant_title : '';
            drawerItemVariant.style.display = hasVariant ? '' : 'none';
          }
          if (drawerItemMeta) drawerItemMeta.textContent = (hnlIsEn ? 'Qty ' : 'Qté ') + item.quantity + ' · ' + formatMoney(item.final_line_price);
        }
        if (drawerSummary) {
          if (cart) {
            var plural = cart.item_count > 1 ? 's' : '';
            drawerSummary.textContent = hnlIsEn
              ? cart.item_count + ' item' + plural + ' in your cart — Subtotal ' + formatMoney(cart.total_price)
              : cart.item_count + ' article' + plural + ' dans votre panier — Sous-total ' + formatMoney(cart.total_price);
          } else {
            drawerSummary.textContent = '';
          }
        }
        document.documentElement.style.overflow = 'hidden';
        if (drawerOverlay) drawerOverlay.classList.add('is-open');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        var firstClose = drawer.querySelector('[data-hnl-drawer-close]');
        if (firstClose) firstClose.focus();
      }

      function closeCartDrawer() {
        if (!drawer) return;
        document.documentElement.style.overflow = '';
        if (drawerOverlay) drawerOverlay.classList.remove('is-open');
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (addToCartBtn) addToCartBtn.focus();
      }

      if (drawerOverlay) drawerOverlay.addEventListener('click', closeCartDrawer);
      drawerCloseEls.forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCartDrawer();
      });

      // Ajout au panier (AJAX réel) — inclut la quantité sélectionnée
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          var variantId = addToCartBtn.getAttribute('data-variant-id');
          if (!variantId) return;
          var checkedInput = root.querySelector('[data-hnl-variant-input]:checked');
          var addedQuantity = getQuantity();
          var payload = { items: [{ id: parseInt(variantId, 10), quantity: addedQuantity }] };
          if (isSubscribeActive && checkedInput) {
            var planId = checkedInput.getAttribute('data-plan-id');
            if (planId) payload.items[0].selling_plan = parseInt(planId, 10);
          }

          addToCartBtn.disabled = true;
          var originalHTML = addToCartBtn.innerHTML;
          addToCartBtn.innerHTML = hnlIsEn ? '<span>Adding…</span>' : '<span>Ajout en cours…</span>';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (res) {
              if (!res.ok) return res.json().then(function (err) { throw err; });
              return res.json();
            })
            .then(function (data) {
              if (atcStatus) atcStatus.textContent = hnlIsEn ? 'Product added to cart.' : 'Produit ajouté au panier.';
              addToCartBtn.innerHTML = hnlIsEn ? '<span>Added ✓</span>' : '<span>Ajouté ✓</span>';

              // Synchronise le compteur du panier dans le header (composant natif du thème) :
              // le thème écoute l'évènement 'cart:update' sur document, pas 'cart:refresh'
              // (qui n'était écouté par rien). Sans ceci, la pastille du header ne bouge pas.
              try {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: data || {},
                    sourceId: 'hnl-pdp-' + (root.id || 'sidr'),
                    data: {
                      source: 'product-form-component',
                      itemCount: addedQuantity
                    }
                  }
                }));
              } catch (hnlCartEventError) {}

              var addedItem = data && data.items && data.items[0] ? data.items[0] : null;

              var postAddAction = root.dataset.hnlPostAddAction || 'drawer';
              if (postAddAction === 'cart_page') {
                window.location.href = '/cart';
              } else if (postAddAction === 'drawer') {
                fetch('/cart.js')
                  .then(function (res) { return res.json(); })
                  .then(function (cart) {
                    openCartDrawer(addedItem, cart);
                  })
                  .catch(function () {
                    openCartDrawer(addedItem, null);
                  })
                  .finally(function () {
                    setTimeout(function () {
                      addToCartBtn.innerHTML = originalHTML;
                      addToCartBtn.disabled = false;
                    }, 600);
                  });
              } else {
                setTimeout(function () {
                  addToCartBtn.innerHTML = originalHTML;
                  addToCartBtn.disabled = false;
                }, 1800);
              }
            })
            .catch(function (err) {
              if (atcStatus) atcStatus.textContent = (err && err.description) ? err.description : (hnlIsEn ? 'An error occurred.' : 'Une erreur est survenue.');
              addToCartBtn.innerHTML = originalHTML;
              addToCartBtn.disabled = false;
            });
        });
      }

      // Cross-sell : ajout rapide du produit complémentaire (avec ou sans reduction automatique selon la page)
      var crossSellBtn = root.querySelector('[data-hnl-cross-sell-add]');
      if (crossSellBtn) {
        crossSellBtn.addEventListener('click', function () {
          var label = crossSellBtn.querySelector('[data-hnl-cross-sell-label]');
          var variantId = crossSellBtn.getAttribute('data-variant-id');
          var hnlSourceHandle = crossSellBtn.getAttribute('data-source-handle') || '';
          var hnlTargetHandle = crossSellBtn.getAttribute('data-target-handle') || '';
          function hnlPublishCrossSellEvent(eventName) {
            try {
              if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
                window.Shopify.analytics.publish(eventName, { source_product: hnlSourceHandle, target_product: hnlTargetHandle });
              }
            } catch (hnlAnalyticsError) {}
          }
          hnlPublishCrossSellEvent('custom_cross_sell_click');
          crossSellBtn.disabled = true;
          if (label) label.textContent = hnlIsEn ? 'Adding...' : 'Ajout...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_cross_sell_source': hnlSourceHandle } }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              return res.json();
            })
            .then(function () {
              hnlPublishCrossSellEvent('custom_cross_sell_add_to_cart');
              window.location.href = '/cart';
            })
            .catch(function () {
              crossSellBtn.disabled = false;
              if (label) label.textContent = hnlIsEn ? 'Retry' : 'Reessayer';
            });
        });
      }
    });
